export default "__VITE_ASSET__DE4T8H2k__"